import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { easeOut } from 'ol/easing';
import PropTypes from 'prop-types';

export default function Zoom({ map }) {
  const zoomByDelta = (delta) => {
    const view = map.getView();
    const currentZoom = view.getZoom();
    if (currentZoom !== undefined) {
      const newZoom = view.getConstrainedZoom(currentZoom + delta);
      if (view.getAnimating()) {
        view.cancelAnimations();
      }
      view.animate({
        zoom: newZoom,
        duration: 250,
        easing: easeOut,
      });
    }
  };

  return (
    <Paper elevation={4} sx={{ p: '2px' }}>
      <Stack spacing={1}>
        <IconButton color="primary" aria-label="zoom-in" title="Zoomer" onClick={() => zoomByDelta(1)}>
          <AddIcon />
        </IconButton>
        <IconButton color="primary" aria-label="zoom-out" title="Dézoomer" onClick={() => zoomByDelta(-1)}>
          <RemoveIcon />
        </IconButton>
      </Stack>
    </Paper>
  );
}

Zoom.propTypes = {
  map: PropTypes.object.isRequired,
};
